<template>
  <div v-if="showError" :key="String(errorKey)" class="error-boundary">
    <page-content-placeholder
      :img-src="PlaceholderImg"
      text="Не удалось загрузить данные.<br /> Попробуйте перезагрузить страницу"
    >
      <e-btn variant="primary" class="mt-6" prepend-icon-src="refresh" @click="reload">Перезагрузить страницу </e-btn>
    </page-content-placeholder>
  </div>
  <slot v-else :key="`${errorKey}_slot`" />
</template>

<script setup lang="ts">
import { isArray } from '@apollo/client/utilities';
import { onBeforeUnmount, toRef } from 'vue';
import PlaceholderImg from '@/assets/img/layouts/content-error-placeholder-image.svg';
import PageContentPlaceholder from '@/core/components/common/PageContentPlaceholder.vue';
import { EBtn } from '@/core/components/ui';
import { type PageErrorKey, usePageErrorStore } from '@/parts/errors/store/pageErrorStore';

const props = defineProps<{
  errorKey: PageErrorKey | PageErrorKey[];
}>();

defineSlots<{
  default: () => void;
}>();

const { pageErrorKey, setPageErrorKey } = usePageErrorStore();

const showError = toRef(() =>
  isArray(props.errorKey)
    ? (props.errorKey as PageErrorKey[]).some((key) => pageErrorKey.value === key)
    : pageErrorKey.value === props.errorKey,
);

const reload = () => {
  location.reload();
};

onBeforeUnmount(() => {
  setPageErrorKey(undefined);
});
</script>

<style scoped lang="scss">
.error-boundary {
  display: flex;

  width: 100%;
  height: 100%;

  background-color: $main-bg-color;
  border-radius: $border-radius-xl;
}
</style>
